/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGirl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 .964A3 3 0 0 1 15 9a1 1 0 0 0 .866-.5l1.732 1a3.002 3.002 0 0 1-3.292 1.42A2.994 2.994 0 0 1 12 12a2.995 2.995 0 0 1-2.355-1.142A3.001 3.001 0 0 1 6.134 9.5l1.732-1A1 1 0 0 0 9 8.964zM9.434 13h5.132l4.2 7H15v2H9v-2H5.234zM11 20h2v-2h2.234l-1.8-3h-2.868l-1.8 3H11z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGirl as Girl };
